import React, { useContext, useState } from "react";
import { ContextContent } from "../contentContext";
import Button from "../../../components/button";
import ModalYesNo from "../../../components/modals/modal-yes-no";
import "./styles.css";

// Футер контента: кнопки по типу. Страница-форма кнопки НЕ рисует.
// edit → «Удалить» (через ModalYesNo, по праву destroy) + «Сохранить»;
// create → «Создать»; show/index → ничего.
// isWithDestroy={false} убирает удаление совсем — для разделов, где эндпоинта DELETE нет
// (напр. файлы): права на фронте по умолчанию выключены, одного checkPermission мало.
export default function ContentFooter() {
    const contextContent = useContext(ContextContent);
    const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);

    if (contextContent.isEdit) {
        return <div className="content__footer">
            {contextContent.isWithDestroy && contextContent.checkPermission('destroy')
                ? <Button className="btn-danger" onClick={() => setIsOpenModalDelete(true)}>Удалить</Button>
                : null}
            <Button className="btn-success" onClick={contextContent.doUpdate}>Сохранить</Button>
            <ModalYesNo
                isOpenModal={isOpenModalDelete}
                closeModal={() => setIsOpenModalDelete(false)}
                title="Удалить запись без возможности восстановления?"
                actionBtnYes={() => {
                    setIsOpenModalDelete(false);
                    contextContent.doDelete();
                }}
                actionBtnNo={() => setIsOpenModalDelete(false)}
            />
        </div>;
    }

    if (contextContent.isCreate || contextContent.isCreateChild) {
        return <div className="content__footer">
            <Button className="btn-success" onClick={contextContent.doCreate}>Создать</Button>
        </div>;
    }

    // Разделы без edit-режима, но с удалением (библиотека приложений)
    if (contextContent.isShow && contextContent.isWithDestroy && contextContent.isWithDestroyOnShow && contextContent.checkPermission('destroy')) {
        return <div className="content__footer">
            <Button className="btn-danger" onClick={() => setIsOpenModalDelete(true)}>Удалить</Button>
            <ModalYesNo
                isOpenModal={isOpenModalDelete}
                closeModal={() => setIsOpenModalDelete(false)}
                title="Удалить запись без возможности восстановления?"
                actionBtnYes={() => {
                    setIsOpenModalDelete(false);
                    contextContent.doDelete();
                }}
                actionBtnNo={() => setIsOpenModalDelete(false)}
            />
        </div>;
    }

    return null;
}
